import { getSignupApi } from "../../api/home/signupApi";
import {
  GET_SIGNUP_SUCCESS,
  GET_SIGNUP_FAILURE,
} from "../types";

export const getSignupSuccess = (homepage) => ({
  type: GET_SIGNUP_SUCCESS,
  payload: homepage,
});

export const getSignupFailure = (error) => ({
  type: GET_SIGNUP_FAILURE,
  payload: error,
});

export const getSignup = (postData) => {
  return (dispatch) => {
    getSignupApi(postData)
      .then((response) => {
        dispatch(getSignupSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getSignupFailure(error.message));
      });
  };
};
